import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["map", "mapMarker", "locateMeButton", "currentLocationIcon", "backToMapButton"]
  static values = {
    lat: Number,
    lng: Number,
    locateMeID: { type: String, default: "locate-me-layer" },
  }
  connect() {
    this.map = false
    this.load = false

    this._loadMapOnce()
  }

  async handleLocateMe() {
    navigator.geolocation.getCurrentPosition(this._lookupCoordinates.bind(this))
    this.locateMeButtonTarget.classList.add("hidden")
    this.backToMapButtonTarget.classList.remove("hidden")
  }

  handleBackToMap() {
    this._removeLine()
    this.locateMeButtonTarget.classList.remove("hidden")
    this.backToMapButtonTarget.classList.add("hidden")
  }

  _loadMapOnce() {
    if (!this.load) {
      this.load = true

      this.map = new window.mapboxgl.Map({
        container: this.mapTarget,
        center: new window.mapboxgl.LngLat(this.lngValue, this.latValue),
        style: "https://api.maptiler.com/maps/positron/style.json?key=AUqGbDDrd3lWF7lPdu0g",
        zoom: 14,
        interactive: false
      })

      this.map.addControl(
        new window.mapboxgl.NavigationControl({showCompass: false}),
        "top-left"
      )

      new window.mapboxgl.Marker({
        element: this.mapMarkerTarget,
        offset: {
          x: 0,
          y: -40
        }
      }).setLngLat([this.lngValue, this.latValue])
        .addTo(this.map)
      this.map.scrollZoom.disable()

      this.map.resize()
    }
  }

  _drawLine(coordinates) {
    if (this.map){
      this.map.addLayer({
        "id": this.locateMeIDValue,
        "type": "line",
        "source": {
          "type": "geojson",
          "data": {
            "type": "Feature",
            "properties": {},
            "geometry": {
              "type": "LineString",
              "coordinates": coordinates
            }
          }
        },
        "layout": {
          "line-join": "round",
          "line-cap": "round"
        },
        "paint": {
          "line-color": "#4dc4e2",
          "line-width": 5
        }
      })

      const bounds = coordinates.reduce(function(bounds, coord) {
        return bounds.extend(coord)
      }, new window.mapboxgl.LngLatBounds(coordinates[0], coordinates[0]))
      this.map.fitBounds(bounds, {
        padding: 50
      })
      new window.mapboxgl.Marker({
        element: this.currentLocationIconTarget,
        offset: {
          x: 0,
          y: -20
        }
      }).setLngLat(coordinates[0])
        .addTo(this.map)

      this.currentLocationIconTarget.classList.remove("hidden")
    }
  }

  _removeLine() {
    if (this.map){
      this.map.flyTo( { center: [this.lngValue, this.latValue] ,zoom: 14} )
    }
  }

  _lookupCoordinates(position) {
    const lat = position.coords.latitude
    const long = position.coords.longitude
    const URL = `https://api.mapbox.com/directions/v5/mapbox/driving/${long},${lat};${this.lngValue},${this.latValue}?overview=full&geometries=geojson&access_token=pk.eyJ1IjoibmVhcmN1dCIsImEiOiJjamtlNHV0bnkwMWdkM2ttamM4bHFzdWgxIn0.7aVrXPb3WXLgFuchjTK6JQ`

    fetch(URL)
      .then(response => response.json())
      .then(result => {
        if (result.code === "Ok") {
          const coordinates = result.routes[0].geometry.coordinates
          this._drawLine(coordinates)
        } else {
          console.warn(result.message)
        }
      })

  }
}
